import React from "react";
import { useHistory } from "react-router-dom";
import { v4 as uuidV4 } from "uuid";
import Slider from "react-slick";

import * as S from "./styles";
import { BoxTreatment } from "components/Shared";

export const Treatments: React.FC = () => {
  const history = useHistory();
  const settings = {
    slidesToShow: 4,

    speed: 500,
    adaptiveHeight: true,
    nextArrow: (
      <S.NextButton>
        <S.IconNext />
      </S.NextButton>
    ),
    prevArrow: (
      <S.PrevButton>
        <S.IconPrev />
      </S.PrevButton>
    ),
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          dots: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "0px",
          dots: true,
        },
      },
    ],
  };
  const treatments = [
    {
      image: <S.IconRaspagem />,
      title: "Raspagem de tártaro",
      text: "Remove a placa bacteriana calcificada (tártaro), deixando o dente liso e polido, evitando sangramento e devolvendo a saúde periodontal.",
    },
    {
      image: <S.IconClareamento />,
      title: "Clareamento dental",
      text: "Já conhece o clareamento da Orthopride? Nosso tratamento remove as pigmentações que amarelam ou escurecem os dentes, mudando rapidamente a cor e a estética, deixando o sorriso mais claro e bonito. Para realizar este procedimento, é necessário agendar uma avaliação com o seu dentista",
    },
    {
      image: <S.IconPrevencao />,
      title: "Prevenção Kids",
      text: "Responsável por prevenir o acúmulo de placa bacteriana, a escovação e o uso do fio dental são as melhores formas de manter uma boa higiene bucal.",
    },
    {
      image: <S.IconOrtho />,
      text: "O kit de clareamento dentário Orthopride Whitening inclui uma moldeira de LED e 3 canetas com gel clareador, que facilitam a aplicação do produto devido à sua praticidade. Para realizar o procedimento, é necessário agendar uma avaliação com seu dentista.",
    },
    {
      image: <S.IconRestauracao />,
      title: "Restauração Dentária",
      text: "É um tratamento seguro e rápido que reconstrói e recupera dentes danificados geralmente por cárie, traumas ou fraturas, devolvendo sua forma, função e estética natural do sorriso.",
    },
    {
      image: <S.IconExtracao />,
      title: "Extração Dentária",
      text: "É um procedimento realizado para remover dentes que estão muito danificados, com cáries profundas, fraturas, infecções ou falta de espaço na arcada dentária. É essencial que seja feita após avaliação cuidadosa do dentista, garantindo segurança e o melhor cuidado para saúde bucal.",
    },
  ];
  return (
    <S.Container>
      <S.Content>
        <S.Title>
          Outros <br />
          <span>tratamentos</span> dentários
        </S.Title>
        <S.Text>
          Garanta um sorriso perfeito com os tratamentos odontológicos da
          Orthopride.
        </S.Text>
        <S.Wrapper>
          <Slider {...settings}>
            {treatments.map((treatment) => (
              <S.WrapperSlide>
                <BoxTreatment key={uuidV4()} data={treatment} />
              </S.WrapperSlide>
            ))}
          </Slider>
        </S.Wrapper>
        <S.TreatmentsButton onClick={() => history.push("/tratamentos")}>
          Conheça nossos Tratamentos
        </S.TreatmentsButton>
      </S.Content>
    </S.Container>
  );
};
